import { TokenRefreshLink } from 'apollo-link-oauth-token-refresh';
import { useDispatch } from 'react-redux';

import {
  getExpirationDate,
  getToken,
  setExpirationDate,
  setMode,
  setRefreshToken,
  setToken,
} from '@utils/localStorage';
import { calculateExpirationTime, isExpired } from '@utils/date';
import loginClient from '@services/OAuthServices/loginClient';
import { fetchUserStart } from '@store/user/actions';
import { logOut } from '@store/auth/actions';
import { cleanUser } from '@store/legacyUser/actions';
import { cleanUserStatus } from '@store/userStatus/actions';
import { cleanUserProfile } from '@store/legacyUserProfile/actions';
import { clearInvitations } from '@store/invitations/actions';
import { clearOrders } from '@store/orders/actions';
import { clearEvaluations } from '@store/legacyEvaluations/actions';
import { clearRouter } from '@store/router/actions';

const isValidClientToken = (): boolean => {
  const checkToken = getToken();
  const expires = getExpirationDate();

  if (checkToken === null || checkToken === '' || expires === '' || expires === null) {
    return false;
  }

  return !isExpired(expires);
};

const OAuthLink = () => {
  const dispatch = useDispatch();

  return new TokenRefreshLink({
    isTokenValidOrUndefined: isValidClientToken,
    fetchAccessToken: () => {
      dispatch(fetchUserStart());
      dispatch(logOut());
      dispatch(cleanUser());
      dispatch(cleanUserStatus());
      dispatch(cleanUserProfile());
      dispatch(clearInvitations());
      dispatch(clearOrders());
      dispatch(clearEvaluations());
      dispatch(clearRouter());
      return loginClient();
    },
    handleResponse: () => (response: { error?: any; token_type?: any; access_token?: any; expires_in?: any }) => {
      const { token_type: type, access_token: token, expires_in: expires } = response;
      if (token) {
        const tokenRefreshed = `${type} ${token}`;
        const expirationDate = calculateExpirationTime(expires);

        setToken(tokenRefreshed);
        setExpirationDate(`${expirationDate}`);
        setRefreshToken('');
        setMode('client');

        return true;
      }

      setToken('');
      setRefreshToken('');
      localStorage.clear();
      return false;
    },
    handleError: () => {
      setToken('');
      setRefreshToken('');
      localStorage.clear();
    },
  });
};

export default OAuthLink;
